export default {
  // Page Header
  page_header: {
    title: "Канали",
    description: "Следете връзките към апаратите и управлявайте каналите за комуникация с Iris Core.",
    metadata: {
      locations: {
        label: "Локации",
        tooltip: "Локации с конфигурирани комуникационни канали",
      },
      instruments: {
        label: "Апарати",
        tooltip: "Апарати, свързани с поне един канал",
      },
      running: {
        label: "Работещи",
        tooltip: "Канали, стартирани от Iris Core",
      },
      connected: {
        label: "Свързани",
        tooltip: "Канали с активна TCP връзка към апарат",
      },
      disabled: {
        label: "Неактивни",
        tooltip: "Канали, изключени от конфигурацията",
      },
    },
    action_buttons: {
      add: {
        label: "Добавяне на канал",
        tooltip: "Добавяне на комуникационен канал",
      },
      refresh: {
        label: "Обновяване",
        tooltip: "Обновяване на списъка с канали",
      },
    },
  },

  // Content
  channel_card: {
    action_buttons: {
      start: "Стартиране",
      stop: "Спиране",
      console: "Дистанционен достъп",
      console_description: "Отваряне на дистанционна работна сесия за този канал",
      edit: "Редактиране на канал",
      edit_description: "Промяна на протокол, порт, апарат или активност",
      delete: "Изтриване на канал",
      delete_description: "Премахване на този комуникационен канал",
      more_actions: "Още действия",
      tests: "Тестове",
      tests_description: "Преглед и управление на тестовете на апарат",
    },
  },
  channels_table: {
    tabs: {
      all: "Канали",
    },
    summary: {
      running: "{count} активни",
      connected: "{count} свързани",
      disabled: "{count} неактивни",
    },
    columns: {
      channel: "Канал",
      instrument: "Апарат",
      driver: "Драйвер / Протокол",
      driver_tooltip: "Комуникационен протоколен драйвер, използван за анализ на съобщенията от апарат.",
      port: "Порт",
      port_tooltip: "TCP портът, на който каналът слуша за входящи данни от апарат.",
      enabled: "Активен",
      enabled_column_tooltip: "Активираните канали могат да се стартират, а деактивираните не участват в обработката.",
      note: "Бележка",
    },
    collapse_group: "Свиване на групата по локация",
    expand_group: "Разгъване на групата по локация",
    navigate_instrument: "Отваряне на детайли на апарат",
    filter_location: "Локация",
    filter_location_all: "Всички локации",
    filter_location_tooltip: "Филтриране на канали по локация",
    filter_location_active_tooltip: "Показват се канали от: {name}. Кликнете за промяна.",
    empty: {
      title: "Няма налични канали",
      description: "Създайте комуникационен канал, за да свържете апарат с Iris Core.",
    },
  },
  channel_crud: {
    add: "Добавяне на канал",
    add_title: "Добавяне на канал",
    add_subtitle: "Създаване на комуникационна връзка към апарат",
    onboarding_title: "Настройка на комуникационен канал",
    onboarding_subtitle: "Последна стъпка след създаване на апарат",
    onboarding_hint:
      "Апаратът е създаден. Сега изберете драйвер / протокол и TCP порт, за да може Iris да комуникира с него.",
    edit_title: "Редактиране на канал",
    view_title: "Детайли за канал",
    delete_title: "Изтриване на канал",
    delete_message: "Този канал ще бъде премахнат окончателно.",
    delete_running_connected_message:
      "Каналът работи и устройство е активно свързано. Спирането ще затвори активната TCP сесия и ще премахне канала окончателно.",
    delete_running_message: "Каналът работи и слуша за TCP връзки. Ще бъде спрян и премахнат окончателно.",
    delete_stopped_connected_message:
      "Каналът е спрян, но устройство все още има отворена връзка. Изтриването ще я затвори окончателно.",
    protocol_hint:
      "Протоколът се избира чрез драйвера на апарат. Каналът свързва един апарат с Iris чрез драйвер и TCP порт.",
    view_mode_edit_btn: "Редактиране",
    view_mode_btn: "Преглед",
    view_subtitle: 'Кликнете "Редактиране", за да промените настройките на канал',
    edit_mode_confirm_btn: "Режим редактиране",
    running_edit_blocked: "Каналът е активен — спрете го преди редактиране",
    running_banner: "Каналът е активен. Спрете го преди да правите промени.",
    stop_and_edit: "Спиране и редактиране",
    stop_and_delete: "Спиране и изтриване",
    stop_and_delete_confirm_title: "Спиране и изтриване на канал",
    stop_and_delete_confirm_body:
      "Това ще спре канала, ще затвори всички активни TCP сесии и ще го премахне окончателно. Това действие не може да бъде отменено.",
    delete_confirm_title: "Окончателно изтриване на канал",
    delete_confirm_body: "Каналът ще бъде премахнат окончателно и не може да бъде възстановен. Сигурни ли сте?",
    running_blocked_title: "Каналът е стартиран",
    running_blocked_body:
      "Каналът в момента е стартиран и приема TCP връзки. Редактирането не е позволено докато каналът е активен — спрете го, за да направите промени по конфигурацията.",
    edit_confirm_title: "Редактиране на канал",
    edit_confirm_body:
      "Ще преминете в режим на редактиране. Можете да промените настройките на канала: име, порт, апарат, драйвер / протокол, активност и бележка.",
    save_confirm_title: "Запазване на промените",
    save_confirm_body:
      "Промените ще бъдат изпратени към Iris Core и ще бъдат показани в списъка само след успешно потвърждение от сървъра.",
    unsaved_title: "Незапазени промени",
    unsaved_save_and_close: "Запазване и продължаване",
    unsaved_discard: "Отхвърляне",
    unsaved_stay: "Остани",
    fields: {
      name: "Име на канал",
      name_hint: "Видимо име за тази комуникационна връзка.",
      name_placeholder: "напр. Cobas e801 TCP канал",
      port: "Порт",
      port_hint: "TCP портът, използван от Iris Core за комуникация с апарат.",
      port_placeholder: "напр. 5001",
      instrument: "Апарат",
      instrument_hint: "Физическият апарат, към който се свързва този канал.",
      instrument_lis_id_label: "LIS ID",
      driver: "Драйвер / Протокол",
      driver_hint: "Драйвер / протокол и модел за конкретния апарат.",
      enabled: "Активен",
      enabled_active: "Активиран",
      enabled_inactive: "Деактивиран",
      enabled_active_hint: "Каналът е активиран — може да се стартира и приема TCP връзки.",
      enabled_inactive_hint: "Каналът е деактивиран — не участва в обработката.",
      note: "Бележка",
      note_hint: "По избор — оперативна бележка за този канал.",
      note_placeholder: "напр. Основен интерфейс на анализатора, маса 2",
      note_empty: "Без бележка",
    },
    form_sections: {
      basic: "Основни настройки",
      connection: "Връзка с апарат",
      operation: "Състояние и бележка",
    },
    validation: {
      name_required: "Името на канала е задължително",
      name_taken: "Вече съществува канал с това име",
      name_too_long: "Името на канала е предолго — максимум {max} знака",
      port_required: "Портът е задължителен",
      port_taken: "Този порт вече се използва от друг канал",
      instrument_required: "Апаратът е задължителен",
      driver_required: "Протоколът / драйверът е задължителен",
      note_too_long: "Бележката е твърде дълга — максимум {max} знака",
    },
    driver_picker_search: "Търсене по производител или модел…",
    driver_no_results: "Няма намерени драйвери за търсенето.",
    snackbar_created: "Каналът {name} беше създаден",
    snackbar_updated: "Каналът {name} беше обновен",
    snackbar_deleted: "Каналът {name} беше изтрит",
    snackbar_save_failed: "Каналът не можа да бъде записан — проверете полетата и опитайте отново",
    snackbar_delete_failed: "Каналът не можа да бъде изтрит — опитайте отново",
    snackbar_stop_before_delete_failed: "Каналът {name} не можа да бъде спрян — не беше изтрит",
    subtitle_channel: "Канал",
    subtitle_channel_id: "ID на канал",
    subtitle_channel_id_tooltip: "Уникален идентификатор на канала в системата",
    subtitle_location: "Локация",
    subtitle_location_tooltip: "Локацията, към която принадлежи апаратът",
  },
  channel: "канал",
  channels: "канала",
  online: "Онлайн",
  offline: "Офлайн",
  connected: "Свързан",
  not_connected: "Не е свързан",
  channel_status: {
    disabled: "Каналът е деактивиран",
    stopped: "Спрян, готов за стартиране",
    stopped_connected: "Спрян, устройството е все още свързано",
    running_waiting: "Работи, няма TCP връзка",
    running_connected: "Работи и е свързан",
  },
  instrument_name: "Име на апарат",
  driver_id: "ID на драйвера",
  port: "Порт",

  // Empty State
  no_channels_title: "Няма налични канали",
  no_channels_description: "В момента няма конфигурирани канали. Моля, проверете връзката или обновете.",
  refresh_channels: "Обновяване",
};
